// 根据具体需要分类。主要是方便团队开发，容易归类。
import request from "@/utils/request";
// 引入公共方法
import {
   getLocalStorage
} from "@/utils/auth";
export default {
   // app端自动登录查询
   autoLogin(data) {
      return request({
         url: "/healthModelLogin/authCodeLogin",
         method: "POST",
         params: data,
      });
   },
   // weChat端自动登录查询
   isLogin(data) {
      return request({
         url: "/healthModelLogin/isLogin",
         method: "POST",
         params: data,
      });
   },
   // 获取图形验证码
   getImgCode() {
      return request({
         url: "/healthModelSms/get",
         method: "GET",
      });
   },
   // 获取短信验证码
   getSMSVerificationCode(data) {
      return request({
         url: "/healthModelSms/send/code",
         method: "POST",
         params: data,
      });
   },
   // 手机号登录
   mobileLogin(data) {
      return request({
         url: "/healthModelLogin/bindMobile",
         method: "POST",
         params: data,
      });
   },
   // 获取首页礼品数据
   getHomeData(data) {
      return request({
         url: "/healthModel/healthHomepage",
         method: "POST",
         headers: {
            accessToken: data.accessToken
         },
      });
   },
   // 获取我的礼品数据
   getMyGift(data) {
      return request({
         url: "/healthModel/queryMyGift",
         method: "POST",
         headers: {
            accessToken: data.accessToken
         },
      });
   },
   // 分享领取成功
   getShareSucceed(data) {
      return request({
         url: "/healthModel/shareSucceed",
         method: "POST",
         headers: {
            accessToken: getLocalStorage('userInfo').accessToken,
         },
         params: data,
      });
   },
   // 一重礼领取
   getHealthPayment(data) {
      return request({
         url: "/healthModel/doubleGift",
         method: "POST",
         headers: {
            accessToken: getLocalStorage('userInfo').accessToken,
            "Content-Type": "application/json; charset=UTF-8"
         },
         data: data
      });
   },
   // 二重礼点击分享领取
   getClickShare(data) {
      return request({
         url: "/healthModel/clickShare",
         method: "POST",
         headers: {
            accessToken: getLocalStorage('userInfo').accessToken,
            "Content-Type": "application/json; charset=UTF-8"
         },
         data: data
      });
   },
   // 翻牌
   getHealthDraw(data) {
      return request({
         url: "/healthModel/healthDraw",
         method: "POST",
         headers: {
            accessToken: getLocalStorage('userInfo').accessToken,
         },
         params: data
      });
   },
   // 微信访问统计
   weChatAccess(data) {
      return request({
         url: "/healthModel/weChatAccess",
         method: "POST",
         params: data
      });
   },
   // 广告弹窗
   getAdList(data) {
      return request({
         url: "/healthModeAdvertising/getAdList",
         method: "POST",
         params: data,
      });
   },
   // 广告弹窗浏览
   advertisPageviews(data) {
      return request({
         url: "/healthModeAdvertising/advertisPageviews",
         method: "POST",
         data: data,
         headers: {
            'Content-Type': 'application/json;charset=UTF-8'
         }
      });
   },
   // app统计
   accessViews(data) {
      return request({
         url: "/appAccessLog/accessView",
         method: "POST",
         data: data,
         headers: {
            'Content-Type': 'application/json;charset=UTF-8'
         }
      });
   },
   // 微信统计
   accessViewswx(data) {
      return request({
         url: "/wxAccessLog/wxPageView",
         method: "POST",
         data: data,
         headers: {
            'Content-Type': 'application/json;charset=UTF-8'
         }
      });
   },
   ///ciccv-education/healthModel/oneGiftList礼品列表
   oneGiftList(data) {
      return request({
         url: "/healthModel/oneGiftList",
         method: "POST",
         params: data
      });
   },
};